import { createSlice } from '@reduxjs/toolkit';
import { ICommon } from '../../types/common';

const initialState: ICommon = {
  isNewbuildingSubdomain: false,
  mapOptions: { visible: false },
  mapApiKey: '',
  suggestApiKey: '',
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {},
});

export const { reducer: commonReducer } = commonSlice;
